export const CORE_METRICS = [
  { key: 'gi', label: 'GI 值', aliases: ['GI', 'GI值', '血糖生成指数', '血糖生成指数 GI', '血糖生成指数（GI）'] },
  { key: 'gl', label: 'GL 值', aliases: ['GL', 'GL值', '血糖负荷', '血糖负荷 GL / 份', '血糖负荷（GL）'] },
];
const normalize = value => String(value ?? '').replace(/\s+/g, '').toLowerCase();
const owns = (data, key) => Object.prototype.hasOwnProperty.call(data, key);
export const isCoreMetricField = (field, metric) =>
  [metric.key, `gi-${metric.key}`].includes(field._id) || metric.aliases.some(label => normalize(label) === normalize(field.label));

export const isProductCoreData = data => data?.moduleRole === 'product-core' || normalize(data?.titleConfig?.chinese) === '产品核心数据';

export function readCoreMetric(data, metric) {
  for (const key of [metric.key, `${metric.key}Value`]) {
    if (owns(data, key)) return data[key] ?? '';
  }
  const field = (data.customFields || []).find(field => isCoreMetricField(field, metric));
  return field ? field.value ?? '' : undefined;
}

// Keep existing custom-field IDs and values; do not create duplicate inputs.
export function coreEditorFields(data) {
  return CORE_METRICS.flatMap(metric => {
    const key = [metric.key, `${metric.key}Value`].find(key => owns(data, key));
    if (!key && (data.customFields || []).some(field => isCoreMetricField(field, metric))) return [];
    return [{ key: key || metric.key, label: metric.label, placeholder: `请输入 ${metric.label}` }];
  });
}

export function getProductCoreDefaults(values = {}) {
  return {
    moduleRole: 'product-core', gi: values.gi ?? '', gl: values.gl ?? '', customFields: [], fieldOrder: ['gi', 'gl'],
    titleConfig: { enabled: true, chinese: '产品核心数据', english: 'Product Core Data.', bgColor: '#1e90ff', textColor: '#ffffff' },
  };
}
